<div class="user-tile d-flex flex-md-row align-items-center">
  <gcc-user-ava [user]="user" size="md"></gcc-user-ava>
  <div class="px-2">
    <p class="note semibold mb-1">
      {{ user?.fullName }}
    </p>
    <p class="caption text-gray">{{ user?.emailAddress }}</p>
  </div>
</div>
